export type CampStatus =
  | 'inBearbeitung'
  | 'anmeldungOffen'
  | 'warteliste'
  | 'anmeldungGeschlossen'
  | 'campVorbei'
  | 'campVorbeiAusgeblendet'
  | 'anmeldungInKurze'

/**
 * Camp ist vorbei und soll nirgends mehr in den Terminlisten auftauchen –
 * auch nicht, wenn vergangene Termine angezeigt werden.
 */
export const HIDDEN_CAMP_STATUS = 'campVorbeiAusgeblendet' as const

/** Camp ist vorbei: keine Anmeldung, keine Erinnerungs-Mails. */
export const FINISHED_CAMP_STATUSES: CampStatus[] = ['campVorbei', HIDDEN_CAMP_STATUS]

/** Status values with no registration possible; the inverse of "open" without the start date. */
export const CLOSED_CAMP_STATUSES: CampStatus[] = [
  'inBearbeitung',
  'anmeldungInKurze',
  'anmeldungGeschlossen',
  ...FINISHED_CAMP_STATUSES,
]

export const isFinishedCampStatus = (status?: CampStatus | string | null): boolean =>
  FINISHED_CAMP_STATUSES.includes(status as CampStatus)

/**
 * Darf man sich zu diesem Camp gerade anmelden? Eine einzige Regel für die
 * Camp-Seite (Formular, Anmelde-Button) und die serverseitige Anmeldung –
 * sonst kann eine zwischengespeicherte Seite oder ein offener Tab trotz
 * "In Bearbeitung" noch Anmeldungen auslösen.
 */
export const isRegistrationOpen = (
  camp: { campStatus?: CampStatus | string | null; anmeldungAb?: string | null },
  now: Date = new Date(),
): boolean =>
  !CLOSED_CAMP_STATUSES.includes(camp.campStatus as CampStatus) &&
  (!camp.anmeldungAb || new Date(camp.anmeldungAb) <= now)
